import sortBy from 'lodash/sortBy';

import { type AppState } from "src/core/reducers";

export const getAll = (state: AppState) =>
  sortBy(Object.values(state.group.byId), (g) => g.name);
